import React from 'react';

import { Button, Table } from 'antd';

import { callApiAsync, displayDate } from 'services/util';

import { isArray, isEmpty } from 'util/utils';

import CommonApi from 'constants/CommonApi';

import '../SalespersonHandover/salespersonHandover.less';

/**
 * Audit trail for Salesperson Handover, read from ACCOUNT_SELLER_HISTORY.
 *
 * Deliberately unlinked: nothing in the Settings nav points here, so it is
 * reached only by typing the route. That hides it from day-to-day users -- it
 * is NOT access control. The super-admin checks on this route and on the
 * backend endpoint are what actually protect the data.
 */
function SalespersonHandoverHistory() {
  const [list, setList] = React.useState([]);
  const [truncated, setTruncated] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const load = React.useCallback(async () => {
    setLoading(true);
    const [err, res] = await callApiAsync({ ...CommonApi.SellerHandover.history, request: {} });
    setLoading(false);
    if (err) return;
    setList(isArray(res?.data?.list) ? res.data.list : []);
    setTruncated(Boolean(res?.data?.truncated));
  }, []);

  React.useEffect(() => {
    load();
  }, [load]);

  const columns = [
    {
      title: 'When',
      dataIndex: 'createdAt',
      width: 220,
      render: (text) => <span>{displayDate(text)}</span>,
    },
    {
      title: 'From',
      dataIndex: 'fromSeller',
      render: (text) => <span className="handoverUser">{isEmpty(text) ? '-' : text}</span>,
    },
    {
      title: 'To',
      dataIndex: 'toSeller',
      render: (text) => <span className="handoverUser">{isEmpty(text) ? '-' : text}</span>,
    },
    {
      title: 'Parties',
      dataIndex: 'partyCount',
      width: 100,
      render: (text) => <span>{text ?? 0}</span>,
    },
    {
      title: 'Done by',
      dataIndex: 'changedBy',
      width: 200,
      render: (text) => <span className="handoverUser">{isEmpty(text) ? '-' : text}</span>,
    },
  ];

  return (
    <div className="configurationWrapper handoverWrapper">
      <div className="handoverHistoryHead">
        <h2 className="handoverTitle">Salesperson Handover History</h2>
        <Button onClick={load} loading={loading}>
          Refresh
        </Button>
      </div>

      <p className="handoverHistoryNote">
        Every handover ever performed, newest first. Expand a row to see which parties moved.
        {truncated && ' Older handovers beyond the most recent 1000 rows are not shown.'}
      </p>

      <Table
        className="gx-table-responsive"
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={false}
        scroll={{ y: 460 }}
        rowKey={(record) => record.batchId}
        expandedRowRender={(record) => (
          <ul className="handoverBatchParties">
            {record.parties.map((name, index) => (
              <li key={`${record.batchId}-${index}`}>{isEmpty(name) ? '(deleted party)' : name}</li>
            ))}
          </ul>
        )}
        locale={{ emptyText: 'No handovers have been performed yet' }}
      />
    </div>
  );
}

export default SalespersonHandoverHistory;
